import React, { memo } from "react";
import { useSelector} from 'react-redux'

const CustomPagination = React.memo(
  ({ lastPage, currentPage, onClick, entries, limit = 10 }) => {
    
    const renderPaginationButtons = () => {
      lastPage = Number(lastPage);
      currentPage = Number(currentPage);

      const pagination = [];

      if (lastPage > 1) {
        if (currentPage === 2) {
          if (currentPage !== 1 && currentPage !== lastPage) {
            pagination.push(currentPage);
          }
          if (currentPage + 1 < lastPage) {
            pagination.push(currentPage + 1);
          }
          if (currentPage + 2 < lastPage) {
            pagination.push(currentPage + 2);
          }
        }
        if (currentPage > 1 && currentPage !== 2 && currentPage !== lastPage) {
          if (currentPage - 1 > 1) {
            pagination.push(currentPage - 1);
          }
          if (currentPage !== 1 && currentPage !== lastPage) {
            pagination.push(currentPage);
          }
          if (currentPage + 1 < lastPage) {
            pagination.push(currentPage + 1);
          }
        }
        if (currentPage === 1) {
          if (currentPage + 1 < lastPage) {
            pagination.push(currentPage + 1);
          }
          if (currentPage + 2 < lastPage) {
            pagination.push(currentPage + 2);
          }
          if (currentPage + 3 < lastPage) {
            pagination.push(currentPage + 3);
          }
        }
        if (currentPage === lastPage && lastPage !== 2) {
          if (currentPage - 3 > 1) {
            pagination.push(currentPage - 3);
          }
          if (currentPage - 2 > 1) {
            pagination.push(currentPage - 2);
          }
          if (currentPage - 1 > 1) {
            pagination.push(currentPage - 1);
          }
        }
      }
      const pagesArray = pagination.map((pg, index) => (
        <button
          key={pg}
          className={`btn ${currentPage === pg ? "btn-green" : "btn-white"}`}
          style={{
            // border: "1px solid #cbcbcb",
            borderRadius: 0,
            borderLeft: "none",
            boxShadow: "none",
            backgroundColor: `${domainData?.header_color && currentPage === pg
                                            ? domainData?.header_color
                                            : "fff"
                                        }`,
            color:`${currentPage === pg ? "white" : "black"}`
          }}
          onClick={() => onClick(+pg)}
        >
          {pg}
        </button>
      ));

      pagesArray.unshift(
        <button
          key="initial"
          className={`btn ${currentPage === 1 ? "btn-green" : "btn-white"}`}
          style={{
            // border: "1px solid #cbcbcb",
            borderRadius: 0,
            boxShadow: "none",
            backgroundColor: `${domainData?.header_color && currentPage === 1
                                            ? domainData?.header_color
                                            : "fff"
                                        }`,
            color:"white"
           
          }}
          onClick={() => onClick(1)}
        >
          1
        </button>
      );
      if (lastPage !== 1 && currentPage <= lastPage) {
        pagesArray.push(
          <button
            key="last-page"
            className={`btn ${
              currentPage === lastPage ? "btn-green" : "btn-white"
            }`}
            style={{
              // border: "1px solid #cbcbcb",
              borderRadius: 0,
              borderLeft: 0,
              boxShadow: "none",
            }}
            onClick={() => onClick(+lastPage)}
          >
            {lastPage}
          </button>
        );
      }
      pagesArray.unshift(
        <button
          key="prev"
          className="btn"
          style={{
            // border: "1px solid #cbcbcb",
            borderRight: "none",
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
          }}
          disabled={currentPage === 1}
          onClick={() => (currentPage === 1 ? null : onClick(currentPage - 1))}
        >
          Previous
        </button>
      );
      pagesArray.push(
        <button
          key="next"
          className="btn"
          disabled={currentPage === lastPage}
          // style={{border:'1px solid #cbcbcb',borderRight:'1px solid #cbcbcb',borderLeft:'none',borderTopLeftRadius:0,borderBottomLeftRadius:0}}
          onClick={
            currentPage === lastPage ? null : () => onClick(currentPage + 1)
          }
        >
          Next
        </button>
      );
      return pagesArray;
    };

  const { domainData } = useSelector((state) => state.Website);

    return (
      <div className="row custom-pagination">
        <div className='col-xs-12 col-md-6'>
          {entries === 0 ? (
            <p />
          ) : (
            <p className="mb-0">{`Showing ${
              currentPage * limit - limit > 0 ? currentPage * limit - limit : 1
            } to ${
              currentPage === lastPage ? entries : currentPage * limit
            } of all coupons`}</p>
          )}
        </div>
        <div className='col-xs-12 col-md-6 custom-pagination-pages' >
          <div style={{display:'flex',flexWrap:'wrap'}}>{renderPaginationButtons()}</div>
        </div>
      </div>
    );
  }
);

export default memo(CustomPagination);
